export const state = {
  loading: false,
  uid: null,
};
